var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"thank-you"},[_c('h1',[_vm._v("Ooops, something went wrong...")]),_c('p',[_vm._v("Please try again later.")])])
}]

export { render, staticRenderFns }